/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import bgBG from '../bg-BG/commandIntelligence.js';
import da from '../da/commandIntelligence.js';
import de from '../de/commandIntelligence.js';
import enGB from '../en-GB/commandIntelligence.js';
import enUS from '../en-US/commandIntelligence.js';
import esCO from '../es-CO/commandIntelligence.js';
import etEE from '../et-EE/commandIntelligence.js';
import fiFI from '../fi-FI/commandIntelligence.js';
import frFR from '../fr-FR/commandIntelligence.js';
import hrHR from '../hr-HR/commandIntelligence.js';
import itIT from '../it-IT/commandIntelligence.js';
import ltLT from '../lt-LT/commandIntelligence.js';
import nlNL from '../nl-NL/commandIntelligence.js';
import noNO from '../no-NO/commandIntelligence.js';
import plPL from '../pl-PL/commandIntelligence.js';
import pt from '../pt/commandIntelligence.js';
import roRO from '../ro-RO/commandIntelligence.js';
import ruRU from '../ru-RU/commandIntelligence.js';
import svSE from '../sv-SE/commandIntelligence.js';
import uk from '../uk/commandIntelligence.js';

export const DEFAULT_COMMAND_INTELLIGENCE_LOCALE = 'en-US';

export const COMMAND_INTELLIGENCE_BY_LOCALE = {
  'bg-BG': bgBG,
  da,
  de,
  'en-GB': enGB,
  'en-US': enUS,
  'es-CO': esCO,
  'et-EE': etEE,
  'fi-FI': fiFI,
  'fr-FR': frFR,
  'hr-HR': hrHR,
  'it-IT': itIT,
  'lt-LT': ltLT,
  'nl-NL': nlNL,
  'no-NO': noNO,
  'pl-PL': plPL,
  pt,
  'ro-RO': roRO,
  'ru-RU': ruRU,
  'sv-SE': svSE,
  uk,
};
